import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { ArrayHelpers } from '@shared/helpers/array-helpers';

@Pipe({
  name: 'sort',
  standalone: false
})
export class SortPipe implements PipeTransform {
  /**
   * Pipe to sort an array ordered ascending by default.
   * If not simple data types use optional sortProperty param to specify what to sort on.
   * @param items - array of items to sort
   * @param sortProperty - optional string or array of strings
   * @param order - optional sort direction ('asc' / 'desc')
   **/
  transform(items: Array<any>, sortProperty?: string | string[], order?: 'asc' | 'desc'): Array<any> {
    if (sortProperty) {
      const sortOrder = order ? order : 'asc';
      let sortPropertyArray: string[];

      if (sortProperty instanceof Array) {
        sortPropertyArray = sortProperty;
      } else {
        sortPropertyArray = [sortProperty];
      }

      return ArrayHelpers.sortArray(items, sortPropertyArray, [sortOrder]);
    } else {
      return items.sort();
    }
  }
}

/**
 * @deprecated NgModule should be removed and replaced by standalone
 */
@NgModule({
  declarations: [SortPipe],
  exports: [SortPipe]
})
export class SortPipeModule {}
